export const RegExpressions = {
    emailWithSpaces: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/,
    phoneWithSpaces: /^\s*\+?\d{3,18}\s*$/,
    numbers: /^[0-9]*$/,
};
